module.exports = __webpack_public_path__ + "icon-facebook.ff9b3bed.svg";